import Highlight, { Prism } from 'prism-react-renderer';
import * as React from 'react';
import { Fragment } from 'react';
export const CodeHighlight = (props) => {
    const hasHighlight = props.highlights && props.highlights.length > 0;
    return (React.createElement(Highlight, Object.assign({ Prism: Prism }, props, { language: isMarkdown(props.language) ? 'markdown' : props.language }), ({ tokens, getLineProps, getTokenProps }) => (React.createElement(Fragment, null, tokens.map((line, i) => (
    // eslint-disable-next-line react/jsx-key
    React.createElement("div", Object.assign({}, getLineProps({
        line,
        className: props.highlights && props.highlights.includes(i + 1)
            ? 'react-showroom-line-highlight'
            : hasHighlight
                ? 'react-showroom-line-dim'
                : undefined,
        key: i,
    })), line.map((token, key) => (
    // eslint-disable-next-line react/jsx-key
    React.createElement("span", Object.assign({}, getTokenProps({ token, key }))))))))))));
};
const isMarkdown = (language) => ['md', 'mdx'].includes(language);
//# sourceMappingURL=code-highlight.js.map